import { render, staticRenderFns } from "./LeaveApplicationView.vue?vue&type=template&id=0cc66d12&scoped=true&"
import script from "./LeaveApplicationView.vue?vue&type=script&lang=js&"
export * from "./LeaveApplicationView.vue?vue&type=script&lang=js&"
import style0 from "./LeaveApplicationView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LeaveApplicationView.vue?vue&type=style&index=1&id=0cc66d12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc66d12",
  null
  
)

export default component.exports